import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../lib/cn';

type StandardsEvidenceCardProps = {
  lines?: string[];
  className?: string;
};

export function StandardsEvidenceCard({
  lines = [],
  className,
}: StandardsEvidenceCardProps): ReactElement {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'rounded-dg-card border border-dashed border-slate-200/90 bg-slate-50/50 p-4 dark:border-slate-600/70 dark:bg-slate-900/30',
        className
      )}
    >
      <h3 className="text-dg-card-title font-semibold text-slate-900 dark:text-white">
        {t('audit.gradeStudio.standardsTitle')}
      </h3>
      {lines.length === 0 ? (
        <p className="mt-2 text-dg-secondary text-slate-600 dark:text-slate-400">
          {t('audit.gradeStudio.standardsEmpty')}
        </p>
      ) : (
        <ul className="mt-2 list-inside list-disc text-dg-body text-slate-700 dark:text-slate-300">
          {lines.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
